import { useTranslation } from 'react-i18next'

const MyRaveRCMSettings = () => {
  const { t } = useTranslation()

  return <p>{t('MY_EDGE_RCM_SETTINGS')}</p>
}

export default MyRaveRCMSettings
